import Vue from 'vue'
import Router from 'vue-router'
import FeedItem from '@/components/editor'
import Create from '@/components/create'
import BuildPreview from '@/components/build-preview'

Vue.use(Router)

export default new Router({
	mode: 'history',
		routes: [
		{
			path: '/repository/:repoName',
			name: 'Edit',
			component:FeedItem
		},
		{
			path: '/create',
			name: 'create',
			component: Create
			// beforeEnter: ifNotAuthenticated,
		},
		{
			path: 'buildPreview',
			name: 'buildPreview',
			component: BuildPreview
		}
	]
})